const Arrow = props => (
  <svg viewBox='0 0 26 15' {...props}>
    <path d='M1.00781 1.65723L12.6699 13.3193L24.332 1.65722' stroke='black'
      strokeWidth='2.34096' />
  </svg>

)

export default Arrow



// WEBPACK FOOTER //
// ./components/icons/arrow.js